<p-toast></p-toast>
<p-confirmDialog #cd [style]="{width: '50vw'}">
    <ng-template pTemplate="footer">
        <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
        <button type="button" pButton icon="pi pi-check" label="Si" (click)="cd.accept()"></button>
    </ng-template>
</p-confirmDialog>
<h2 style="text-align: center;">Enfermeras</h2>
<div *ngIf="supervisor" class="container-enfermeras">
    <p-toolbar styleClass="mb-2 gap-2">
        <div class="p-toolbar-group-start">

            <form [formGroup]="enfermeraForm" (ngSubmit)="onSubmit()">
                <div class="formgroup-inline">
                    <div class="field">
                        <p-dropdown [options]="catalogoEnfermeras" optionLabel="nom_enfermera" [filter]="true"
                            filterBy="nom_enfermera" [showClear]="true" formControlName="enfermera"
                            [emptyMessage]="'Sin registros'" [emptyFilterMessage]="'Sin resultados'"
                            placeholder="Seleccione una enfermera"></p-dropdown>
                    </div>
                    <p-button icon="pi pi-user-plus" [disabled]="enfermeraForm.invalid" [type]="'submit'"
                        styleClass="p-button-rounded p-button-info p-button-text p-button-raised"></p-button>
                </div>
            </form>

        </div>
        <div class="p-toolbar-group-end">

        </div>
    </p-toolbar>
    <p-table [value]="enfermeras" [tableStyle]="{ 'min-width': '50rem' }" [styleClass]="'p-datatable-sm'">
        <ng-template pTemplate="header">
            <tr>
                <th>Enfermera</th>
                <th>Teléfono Móvil</th>
                <th>Médicos asociados</th>
                <th>Casos Clinicos</th>
                <th>Puntos</th>
                <th>Acciones</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-enfermera>
            <tr>
                <td><a [routerLink]="['/supervisor/enfermera', enfermera.id]">{{enfermera.nom_enfermera |
                        uppercase}}</a></td>
                <td>{{enfermera.telefonoMovil}}</td>
                <td>{{enfermera.medicos.length}}</td>
                <td>{{enfermera.casosclinicos?.length}}</td>
                <td>{{puntos(enfermera.casosclinicos)}} </td>
                <td><p-button icon="pi pi-user-minus" (onClick)="eliminarEnfermera(enfermera.id)"
                        styleClass="p-button-rounded p-button-danger p-button-text p-button-sm"></p-button></td>

            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5" class="text-center p-4">
                    <div class="flex flex-column align-items-center">
                        <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                        <span class="text-600 mt-2">No se encontraron enfermeras</span>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>

</div>